import React, { FunctionComponent, useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { FaCog } from "react-icons/fa";

import { BackButton } from "../../components/BackButton";
import logo from "../../assets/images/logo.png";
import "./Header.scss";
import { LanguageSwitcher } from "../LanguageSwitcher";
import SizedBox from "../SizedBox/SizedBox";
import Menu from "../Menu/Menu";

const Header: FunctionComponent = () => {
  const history = useHistory();
  const path = history.location.pathname;
  const [url, setUrl] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    if (path) {
      switch (path) {
        case "/result-selection":
          // setUrl(AppRoutes.photoConfirm);
          break;
        case "/verification":
          // setUrl(AppRoutes.authentication);
          break;
        default:
          setUrl("");
      }
    }
  }, [path]);
  
  return (
    <header className="app-header">
      <div className="container">
        <div className="app-header__inner-wrap">
          {url && <BackButton url={url} />}
          <NavLink className="app-header__logo" exact to="">
            <img src={logo} alt="Passcard logo" />
          </NavLink>
        </div>
        <div className="settings-language-container">
          <div
            onClick={() => {
              setShowMenu(true);
            }}
            className="settings-icon-container"
          >
            <FaCog className="settings-icon" />
          </div>
          <SizedBox width={10} />
          <LanguageSwitcher />
        </div>
      </div>
      {showMenu && (
        <Menu
          onClose={() => {
            setShowMenu(false);
          }}
        />
      )}
    </header>
  );
};

export default Header;
